import { Icons } from "components";
import { LeaderboardPreviewStyled } from "./styled";

const LeaderboardPreview = ({
  labelTh,
  labelEn,
  isDisabled,
  onDetailClick,
}) => (
  <LeaderboardPreviewStyled isDisabled={isDisabled}>
    <div className="header_row">
      <div>
        <div className="label_th">{labelTh}</div>
        <div className="label_en">{labelEn}</div>
      </div>
      <button type="button" className="detail_link" disabled={isDisabled} onClick={onDetailClick}>
        ดูรายละเอียด
        <Icons.ArrowRight2 color={isDisabled ? '#949494' : '#002366'} />
      </button>
    </div>
    <div className="image_container"><img src={`${isDisabled ? '/leaderboard-inactive.png' : '/leaderboard-active.png'}`} alt="Company Leaderboard" /></div>
  </LeaderboardPreviewStyled>
);

export default LeaderboardPreview;
